module.exports = __webpack_public_path__ + "static/img/hsteel.5b9e322.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/hsteel.jpg
// module id = EWOr
// module chunks = 0